import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import Swal from "sweetalert2";
import Pagination from "../Pagination/Pagination";

export default function Loans() {
  let [data, setData] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);

  const [pagination, setPagination] = useState({
    totalPages: 1,
    totalItems: 0,
    currentPage: 1,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      
      const response = await axios.get(
        // `http://localhost:3000/admin/loan/applications?page=${pageNumber}&limit=${pageLimit}`,
        `${baseUrl}/admin/loan/applications?page=${pageNumber}&limit=${pageLimit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // console.log("data:", response);
      setPagination({
        totalPages: response?.data?.pagination.totalPages,
        totalItems: response?.data?.pagination.total,
        currentPage: response?.data?.pagination.page,
      });
      setData(response?.data.data || []);
    } catch (error) {
      console.error("Failed to fetch banners", error);
    }
  };

  // const handleStatus = async (id, currentStatus) => {
  //   const newStatus = currentStatus === "active" ? "inactive" : "active";
  //   await axios(`${baseUrl}/banner/${id}/status`, {
  //     method: "PATCH",
  //     headers: {
  //       Authorization: localStorage.getItem("token"),
  //     },
  //     data: {
  //       status: newStatus,
  //     },
  //   });
  //   fetchData();
  //   Swal.fire({
  //     title: "Status Changed!",
  //     icon: "success",
  //     draggable: true,
  //   });
  // };

  // const handleDelete = (id) => {
  //   let apiCall = async () => {
  //     let res = await fetch(`${baseUrl}/banner/${id}`, {
  //       method: "DELETE",
  //       headers: {
  //         Authorization: localStorage.getItem("token"),
  //       },
  //     });
  //     const result = await res.json();
  //     fetchData();
  //   };
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       apiCall();
  //       Swal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         icon: "success",
  //       });
  //     }
  //   });
  // };
  // const handleDelete = (id) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         const res = await fetch(`${baseUrl}/banner/deletebanner/${id}`, {
  //           method: "DELETE",
  //           headers: {
  //             Authorization: localStorage.getItem("token"),
  //           },
  //         });
  //         const data = await res.json();
  //         fetchData()
  //         if (res.ok) {
  //           setData((prev) => prev.filter((b) => b._id !== id));
  //           Swal.fire("Deleted!", "Your banner has been deleted.", "success");
  //         }
  //       } catch (error) {
  //         console.error("Delete error:", error);
  //         Swal.fire("Error", "Failed to delete banner", "error");
  //       }
  //     }
  //   });
  // };

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Loan Applications
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage loan applications and approvals
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row ">
                  <div className="col-lg-6">
                    <h5 className="card-title">Loan List</h5>
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Applicant</th>
                      <th>Purpose</th>
                      <th>Amount</th>
                      <th>Duration</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, i) => {
                      return (
                        <tr key={item?._id}>
                          <td>{i + 1}</td>
                          <td>{item?.user?.fullname || "N/A"}</td>
                          <td>{item?.purpose}</td>
                          <td>₹{item?.amount}</td>
                          <td>{item?.durationMonths} months</td>
                          <td>
                            <span
                              className={`badge ${
                                item?.status === "approved"
                                  ? "bg-success"
                                  : item?.status === "rejected"
                                  ? "bg-danger"
                                  : item?.status === "canceled"
                                  ? "bg-secondary"
                                  : "bg-warning"
                              }`}
                            >
                              {item?.status}
                            </span>
                          </td>

                          <td>
                            <div className="action-buttons">
                              {/* View Details */}
                              <Link
                                className="action-btn edit-btn bg-info"
                                to={`/loans/view/${item?._id}`}
                              >
                                <i className="fa fa-eye" />
                              </Link>

                              {/* If loan is still pending → allow approve/reject/cancel */}
                              {!item?.status === "pending" && (
                                <>
                                  <button
                                    // onClick={() => handleApprove(item?._id)}
                                    className="action-btn edit-btn bg-success"
                                    title="Approve"
                                  >
                                    <i className="fa fa-check"></i>
                                  </button>
                                  <button
                                    // onClick={() => handleReject(item?._id)}
                                    className="action-btn edit-btn bg-danger"
                                    title="Reject"
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                  <button
                                    // onClick={() => handleCancel(item?._id)}
                                    className="action-btn edit-btn bg-secondary"
                                    title="Cancel"
                                  >
                                    <i className="fa fa-ban"></i>
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {pagination.totalPages > 1 && (
                <Pagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  // paginationDetails={paginationDetails}
                  totalPages={pagination.totalPages}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
